import { ImageWrapper } from "@/lib/styles";
import styled from "styled-components";

export const Container = styled(ImageWrapper)`
  padding-bottom: 100%;
  margin-bottom: 1.5rem;
  width: 100%;
`;
